<template>
  <div>
    <client-module
      class="header-title"
      moduletitle="垃圾询盘过滤设置"
      hideBorder
    ></client-module>
    <set-blacklist
      :type="1"
      blacklistTitle="邮件地址黑名单"
      hint="*单个邮件地址，同时发给#*#*个客户时，会被系统识别为垃圾询盘，邮件地址归类到黑名单"
    ></set-blacklist>
    <set-blacklist
      :type="2"
      blacklistTitle="邮件内容黑名单"
      hint="*相同邮件内容，同时发给#*#*个客户时，会被系统识别为垃圾询盘，邮件内容归类到黑名单"
    ></set-blacklist>
    <set-blacklist
      :type="3"
      blacklistTitle="关键词黑名单"
      hint="*当邮件内容包含目标关键词时，会被系统识别为垃圾询盘，邮件归类到黑名单"
    ></set-blacklist>
  </div>
</template>

<script>
import clientModule from '@/components/client/clientModule/clientModule.vue'
import setBlacklist from '@/components/garbageInquiry/setBlacklist.vue'
export default {
  data() {
    return {}
  },
  methods: {},
  components: { clientModule, setBlacklist },
}
</script>

<style lang="scss" scoped>
.header-title {
  background-color: #fff;
}
</style>
